import { ComponentAPI } from '../../../api/bussched/ComponentAPI';

export class CircleElementStyleCommand {
    constructor() {
        this.componentApi = new ComponentAPI();
    }

    getAvailableTargets(componentType, successCallback, errorCallback) {
        const apiResult = this.componentApi.listCircleElementTargets(componentType);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a obter os elementos disponíveis para configuração de um elemento circular");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/CircleElementStyleCommand.js